// extracted by mini-css-extract-plugin
module.exports = {"container":"_2i_y5","wrapper":"_3apHV","listItemMobile":"_2tzJG","pagination":"_2b05N","separator":"_1F_Nl"};